/// <reference path="../_references.ts"/>

module App.Helpers {
	export class UploadService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants,
			protected Upload: ng.angularFileUpload.IUploadService,
		) {

		}

		public upload(url: string, file: File): ng.angularFileUpload.IUploadPromise<any> {
			return this.Upload.upload({
				url: this.Constants.apiUrl + url,
				method: 'POST',
				data: {
					file: file
				}
			});
		}

		public uploadAWS(bucket: string, filepath: string, file: File): ng.IHttpPromise<any> {
			let formData = new FormData();

			formData.append('key', filepath);
			formData.append('file', file);
			formData.append('AWSAccessKeyId', 'AKIA3R3WHY4FJK6UT5OS');
			formData.append('acl', 'public-read');
			formData.append('Content-Type', file.type !== '' ? file.type : 'application/octet-stream');
			formData.append('filename', file.name);

			return this.$http.post('https://' + bucket + '.s3-accelerate.dualstack.amazonaws.com', formData, {
				headers: {
					'Content-Type': undefined
				}
			});
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants, Upload: ng.angularFileUpload.IUploadService) => {
				return new UploadService($http, Constants, Upload);
			};

			instance.$inject = ['$http', 'Constants', 'Upload'];

			return instance;
		}
	}

	angular
		.module('helpers.uploadService', [])
		.factory('UploadService', UploadService.Factory());
}
